import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders} from '@angular/common/http';
import { AccesoService } from '../acceso/acceso.service';
import { environment } from '../../../environments/environment';
import { map } from "rxjs/operators";
import { FiltrosSolicitudes } from 'app/models/FiltrosSolicitudes';

@Injectable({
  providedIn: 'root'
})
export class SolicitudesService {

  readonly urlBase =  environment.rutaBase;
  header : HttpHeaders;
   datos:any;
  constructor(private http: HttpClient,
              private accesoService :AccesoService) { 
  this.header = this.accesoService.desencriptarTOKEN();
  }

  FiltroListadoReclamos(Filtro:FiltrosSolicitudes,FechaIni,FechaFin){
    let headers = this.header;
    return this.http.get(
      `${this.urlBase}/solicitud?id_Empresa=1&pTipoSolicitud=${Filtro.TipoSolicitud}&NroDocumentoIdentidad=${Filtro.NroDocumentoIdentidad}&Codigo=${Filtro.Codigo}&FechaInicial=${FechaIni}&FechaFinal=${FechaFin}&Estado=${Filtro.Estado}`,{headers}
    )
    .pipe(
      map((data) => {
        this.datos = data;         
        return data;
      })
    );
  }

  actualizarEstado(body:any){
    let headers = this.header;
    return this.http.put(`${this.urlBase}/solicitud?id_Empresa=1`,body,{headers})
  }

  guardarSolicitud(body : any){
    let headers = this.header; 
    return this.http
      .post(`${this.urlBase}/solicitud?id_Empresa=1`,body,{headers})
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  guardarRespuesta(body : any){
    let headers = this.header; 
    return this.http
      .post(`${this.urlBase}/respuesta?id_Empresa=1`,body,{headers})
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  ObtenerListadoRespuestas() {
    let headers = this.header;
    return this.http.get(
      `${this.urlBase}/respuesta?id_Empresa=1`,{headers}
    )
    .pipe(
      map((data) => {
        this.datos = data;         
        return data;
      })
    );
  }
}
